import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect, useState } from 'react';

import { MemberTypeForm } from 'components';
import { useEditMemberTypeMutation } from 'store/api/version-api.slice';

import { styles } from '../styles/addMemberTypes.styles';

const EditMemberTypeDialog = ({ editableMemberType, isOpen, handleCloseDialog }) => {
	const [memberType, setMemberType] = useState(editableMemberType || {});

	const [editMemberType, { isLoading }] = useEditMemberTypeMutation();

	const handleEdit = (prop, value) => {
		setMemberType(prev => ({
			...prev,
			[prop]: value
		}));
	};

	const onEditCancel = () => {
		setMemberType(editableMemberType);
		handleCloseDialog();
	};

	const handleSave = async () => {
		const { id, ...payload } = memberType;

		await editMemberType({ id: memberType.id, payload });

		handleCloseDialog();
	};

	useEffect(() => {
		if (editableMemberType) {
			setMemberType(editableMemberType);
		}
	}, [editableMemberType]);

	return (
		<Dialog open={isOpen} onClose={handleCloseDialog} aria-labelledby="form-dialog-title">
			<DialogTitle>Edit Member Type</DialogTitle>
			<DialogContent>
				<MemberTypeForm
					member_type={memberType.member_type || ''}
					amount={memberType.amount || ''}
					renewal={memberType.renewal || ''}
					billing={memberType.billing || ''}
					linked_limit={memberType.linked_limit || ''}
					allow_linked={memberType.allow_linked || false}
					visible={memberType.visible || false}
					directory_list={memberType.directory_list || false}
					free_type={memberType.free_type || false}
					handlePropChange={handleEdit}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onEditCancel}>Cancel</Button>
				<Button variant={'contained'} onClick={handleSave} sx={{ maxWidth: '100px', width: '100%' }}>
					{isLoading && <CircularProgress sx={{ color: '#ffffff', marginRight: '8px' }} size={21} />}
					Save
				</Button>
			</DialogActions>
			{isLoading && <Box sx={styles.overlay}></Box>}
		</Dialog>
	);
};

export default EditMemberTypeDialog;
